// validators/optional.ts
import { AbstractValidator } from "../types.mjs";
import { getValidator } from "../utilities.mjs";
var OptionalValidator = class extends AbstractValidator {
  validator;
  defaultValue;
  constructor(validator, defaultValue) {
    super();
    this.validator = validator;
    this.optional = defaultValue === void 0;
    if (this.optional) {
      this.defaultValue = void 0;
      return;
    }
    try {
      this.defaultValue = validator.validate(defaultValue, {});
    } catch (cause) {
      throw new TypeError("Default value does not match validator", { cause });
    }
  }
  validate(value, options) {
    if (value === void 0) return structuredClone(this.defaultValue);
    return this.validator.validate(value, options);
  }
};
function optional(validation, defaultValue) {
  const validator = getValidator(validation);
  return new OptionalValidator(validator, defaultValue);
}
export {
  OptionalValidator,
  optional
};
//# sourceMappingURL=optional.mjs.map
